
import article0 from './OnData_Portal/Account_Registration';
import article1 from './OnData_Portal/User_Management';
import article2 from './OnData_Portal/OnData_Application_Roles';
import article3 from './OnData_Portal/Data_Classifications';
import article4 from './OnData_Portal/Data_Access_Roles';
import article5 from './OnData_Portal/SSO_Integration/Overview';
import article6 from './OnData_Portal/SSO_Integration/EntraID_Integration_Using_OIDC';
import article7 from './OnData_Portal/SSO_Integration/EntraID_Integration_Using_SAML';
import article8 from './OnData_Portal/SSO_Integration/EntraID_Role_Assignment';
import article9 from './OnData_Portal/SSO_Integration/Okta_Integration_Using_OIDC';
import article10 from './OnData_Portal/SSO_Integration/Okta_Integration_Using_SAML';
import article11 from './OnData_Portal/SSO_Integration/Okta_Role_Assignment';
import article12 from './OnData_Portal/Custom_Cloud_Subscription';
import article13 from './OnData_Portal/Custom_Key_Vault';
import article14 from './SecureDB/Database_Backup/Microsoft SQL Server';
import article15 from './SecureDB/Database_Backup/Oracle';
import article16 from './SecureDB/Database_Backup/PostgreSQL';
import article17 from './SecureDB/Database_Backup/MySQL';
import article18 from './SecureDB/Database_Backup/MariaDB';
import article19 from './SecureDB/Database_Backup/Snowflake';
import article20 from './SecureDB/Database_Backup/DB2';
import article21 from './SecureDB/Database_Download/Download_Databases';
import article22 from './SecureDB/Database_Drivers/OnData_ODBC_Driver';
import article23 from './SecureDB/Database_Drivers/OnData_JDBC_Driver';
import article24 from './SecureDB/Database_Drivers/OnData_SqlClient';
import article25 from './SecureDB/Database_Drivers/OnData_Client_Registration';
import article26 from './SecureDB/Database_Drivers/Client_Resource_Access';
import article27 from './SecureDB/OnData_Encryption/OnData_Encryption_Tool_Overview';
import article28 from './SecureDB/OnData_Encryption/Install_OnData_Encryption_Tool';
import article29 from './SecureDB/OnData_Encryption/Use_OnData_Encryption_Tool';
import article30 from './SecureDB/OnData_Encryption/Automate_OnData_Encryption_Tool';
import article31 from './SecureDB/OnData_Encryption/Migrate_and_Encrypt_Oracle_Database';
import article32 from './SecureDB/OnData_Encryption/Apply_Encryption_Setting_Changes';
import article33 from './SecureDB/OnData_Encryption/Database_Subsetting';
import article34 from './SecureDB/OnData_Encryption/OnData_Encryption_Rules';
import article35 from './SecureDB/OnData_Encryption/Encryption_Best_Practices_and_Limitations';
import article36 from './SecureDB/OnData_Encryption/MongoDB_Encryption_Limitations';
import article37 from './SecureDB/OnData_Encryption/Data_Information_Types';
import article38 from './SecureFile/Installation_and_Configuration/Overview';
import article39 from './SecureFile/Installation_and_Configuration/Install_SecureFile_on_Windows';
import article40 from './SecureFile/Installation_and_Configuration/Register_SecureFile';
import article41 from './SecureFile/Installation_and_Configuration/Silent_Installation_on_Windows';
import article42 from './SecureFile/Installation_and_Configuration/Install_SecureFile_on_MacOS';
import article43 from './SecureFile/Installation_and_Configuration/Silent_Installation_on_MacOS';
import article44 from './SecureFile/Installation_and_Configuration/SecureFile_Settings_on_MacOS';
import article45 from './SecureFile/Installation_and_Configuration/Uninstall_SecureFile';
import article46 from './SecureFile/Using_SecureFile';
import article47 from './SecureFile/Sharing_Files_with_External_Users';
import article48 from './SecureFile/Best_Practices_and_Limitations';
import article49 from './SecureFile/SecureFile_Settings';
import article50 from './SecureFile/Classification_and_Protection_Rules';
import article51 from './SecureFile/File_Information_Types';
import article52 from './SecureFile/Document_Types';
import article53 from './SecureFile/Deploy_Data_Analyzer';
import article54 from './SecureAI/SecureAI_Overview';
import article55 from './SecureAI/Installation_and_Configuration/Overview';
import article56 from './SecureAI/Installation_and_Configuration/Deploy_with_Docker';
import article57 from './SecureAI/Installation_and_Configuration/Configure_SecureAI_App';
import article58 from './SecureAI/Installation_and_Configuration/SSO_Integration';
import article59 from './SecureAI/Data_Query';
import article60 from './SecureAI/Agent_Automation';

const docMap = {
  '/ondata_portal/account_registration': article0,
  '/ondata_portal/user_management': article1,
  '/ondata_portal/ondata_application_roles': article2,
  '/ondata_portal/data_classifications': article3,
  '/ondata_portal/data_access_roles': article4,
  '/ondata_portal/sso_integration/overview': article5,
  '/ondata_portal/sso_integration/entraid_integration_using_oidc': article6,
  '/ondata_portal/sso_integration/entraid_integration_using_saml': article7,
  '/ondata_portal/sso_integration/entraid_role_assignment': article8,
  '/ondata_portal/sso_integration/okta_integration_using_oidc': article9,
  '/ondata_portal/sso_integration/okta_integration_using_saml': article10,
  '/ondata_portal/sso_integration/okta_role_assignment': article11,
  '/ondata_portal/custom_cloud_subscription': article12,
  '/ondata_portal/custom_key_vault': article13,
  '/securedb/database_backup/microsoft sql server': article14,
  '/securedb/database_backup/oracle': article15,
  '/securedb/database_backup/postgresql': article16,
  '/securedb/database_backup/mysql': article17,
  '/securedb/database_backup/mariadb': article18,
  '/securedb/database_backup/snowflake': article19,
  '/securedb/database_backup/db2': article20,
  '/securedb/database_download/download_databases': article21,
  '/securedb/database_drivers/ondata_odbc_driver': article22,
  '/securedb/database_drivers/ondata_jdbc_driver': article23,
  '/securedb/database_drivers/ondata_sqlclient': article24,
  '/securedb/database_drivers/ondata_client_registration': article25,
  '/securedb/database_drivers/client_resource_access': article26,
  '/securedb/ondata_encryption/ondata_encryption_tool_overview': article27,
  '/securedb/ondata_encryption/install_ondata_encryption_tool': article28,
  '/securedb/ondata_encryption/use_ondata_encryption_tool': article29,
  '/securedb/ondata_encryption/automate_ondata_encryption_tool': article30,
  '/securedb/ondata_encryption/migrate_and_encrypt_oracle_database': article31,
  '/securedb/ondata_encryption/apply_encryption_setting_changes': article32,
  '/securedb/ondata_encryption/database_subsetting': article33,
  '/securedb/ondata_encryption/ondata_encryption_rules': article34,
  '/securedb/ondata_encryption/encryption_best_practices_and_limitations': article35,
  '/securedb/ondata_encryption/mongodb_encryption_limitations': article36,
  '/securedb/ondata_encryption/data_information_types': article37,
  '/securefile/installation_and_configuration/overview': article38,
  '/securefile/installation_and_configuration/install_securefile_on_windows': article39,
  '/securefile/installation_and_configuration/register_securefile': article40,
  '/securefile/installation_and_configuration/silent_installation_on_windows': article41,
  '/securefile/installation_and_configuration/install_securefile_on_macos': article42,
  '/securefile/installation_and_configuration/silent_installation_on_macos': article43,
  '/securefile/installation_and_configuration/securefile_settings_on_macos': article44,
  '/securefile/installation_and_configuration/uninstall_securefile': article45,
  '/securefile/using_securefile': article46,
  '/securefile/sharing_files_with_external_users': article47,
  '/securefile/best_practices_and_limitations': article48,
  '/securefile/securefile_settings': article49,
  '/securefile/classification_and_protection_rules': article50,
  '/securefile/file_information_types': article51,
  '/securefile/document_types': article52,
  '/securefile/deploy_data_analyzer': article53,
  '/secureai/secureai_overview': article54,
  '/secureai/installation_and_configuration/overview': article55,
  '/secureai/installation_and_configuration/deploy_with_docker': article56,
  '/secureai/installation_and_configuration/configure_secureai_app': article57,
  '/secureai/installation_and_configuration/sso_integration': article58,
  '/secureai/data_query': article59,
  '/secureai/agent_automation': article60,
}

export default docMap;
